import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchNoticiaPorSlug } from "../utils/contentfulRequests";
import {
  Box,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
} from "@mui/material";

import FloatingActionButton from "../components/FloatingActionButton";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"; // Importa la función para procesar RichText
import Banner from "../components/Banner";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DownloadIcon from "@mui/icons-material/Download";

const NewsDetail = () => {
  const { slug } = useParams(); // Obtiene el slug de la URL
  const [noticia, setNoticia] = useState(null); // Estado para la noticia
  const [loading, setLoading] = useState(true); // Indicador de carga
  const theme = useTheme(); // Accede al tema
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Verifica si el viewport es menor que "sm"

  useEffect(() => {
    const cargarNoticia = async () => {
      try {
        const noticiaData = await fetchNoticiaPorSlug(slug);
        setNoticia(noticiaData);
      } catch (error) {
        // no-op
      } finally {
        setLoading(false);
      }
    };

    cargarNoticia();
  }, [slug]);

  if (loading) {
    return <Typography>Cargando noticia...</Typography>;
  }

  return (
    <Box
      sx={{
        margin: "0 auto",
        padding: isMobile ? "0px" : "24px",
        boxShadow: 3,
      }}
    >
      <Banner title={noticia.titulo} />
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: isMobile ? "minmax(0, 1fr)" : "repeat(2, minmax(0, 1fr))",
          borderRadius: "8px",
          gap: "16px",
          padding: isMobile ? "16px" : "24px",
          boxSizing: "border-box",
          backgroundColor: "#FFFF",
        }}
      >
        <Box
          className="detail-content"
          sx={{
            order: isMobile ? 1 : 2,
            display: "flex",
            width: "100%",
            minWidth: 0,
            height: "fit-content",
            alignSelf: "start",
            flexDirection: "column",
            borderRadius: "8px",
            gap: isMobile ? "4px" : "8px",
            backgroundColor: theme.palette.grayLight.main,
          }}
        >
          <Box
            component="img"
            src={noticia.imagen}
            alt={noticia.titulo}
            sx={{
              display: "block",
              width: "100%",
              height: isMobile ? "auto" : "280px",
              maxWidth: "100%",
              objectFit: "contain",
              objectPosition: "center",
              borderRadius: "8px 8px 0 0",
            }}
          />
          <Box className="information"
          sx={{
            padding: "16px",
          }}
          >
            <Typography
              variant="body2"
              color="textSecondary"
              gutterBottom
              sx={{
                color: theme.palette.primary.main,
                fontWeight: "bold",
                fontSize: "16px",
                display:"flex",
                gap:"8px",
              }}
            >
              <CalendarTodayIcon fontSize="small" />{" "}
              {new Date(noticia.fecha).toLocaleDateString()}
            </Typography>

            {noticia.pdf && (
              <Button
                href={noticia.pdf}
                target="_blank"
                variant="contained"
                sx={{ marginTop: "16px", display: "flex"}}
              >
                <DownloadIcon sx={{ marginRight: "8px" }}/> Descargar PDF
              </Button>
            )}
          </Box>
        </Box>

        <Box sx={{ order: 1, minWidth: 0, width: "100%" }}>
          {noticia.cuerpo && (
            <Box
              sx={{
                backgroundColor: "#FFFF",
              }}
            >
              {documentToReactComponents(noticia.cuerpo)}{" "}
              {/* Renderiza RichText */}
            </Box>
          )}
        </Box>
        
      </Box>
      {noticia.pdf && (
        <FloatingActionButton
          isMobile={isMobile}
          href={noticia.pdf}
          label="Descargar PDF"
        />
      )}
    </Box>
    
  );
};

export default NewsDetail;
